import {
  createVoucher,
  deleteVoucher,
  detailVoucherRedeem,
  duplicateVoucher,
  exportListVoucher,
  getListVoucher,
  getVoucherDetail,
  redeemVoucher,
  updateVoucherDetail,
  updateVoucherRedeem,
} from "@/api/voucher";
import { transformToFormData } from "@/utils/global.util";
import { defineStore } from "pinia";

export const useVoucherStore = defineStore({
  id: "voucher",
  state: () => ({
    isEditVoucher: false,
    basicInfoForm: {
      nameTh: null,
      nameEn: null,
      descriptionTh: null,
      descriptionEn: null,
      packageTypeId: null,
      ticketGroupTncsAttributes: null,
      sellingStartDate: null,
      sellingEndDate: null,
      validStartDate: null,
      validEndDate: null,
      urlLink: null,
    },
    acceptAllMethod: false,
    paymentTypeIds: [1, 2],
    quantityPricingForm: {
      price: 0,
      discountPrice: 0,
      quantity: 0,
      defaultQty: 0,
      limitPerOrder: null,
    },
    data: [],
    pagination: {},
    voucherRedeemDetails: null,
    voucherRedeemGuestDetails: null,
  }),
  getters: {
    getListData: (state) => state.data,
    getPagination: (state) => state.pagination,
    getBasicInfo: (state) => state.basicInfoForm,
    getQuantityPricing: (state) => state.quantityPricingForm,
    getPaymentInfo: (state) => state.paymentTypeIds,
    isAvailableVoucher: (state) => state.data.length > 0,
  },
  actions: {
    clearVoucher() {
      // basicInfoForm
      this.basicInfoForm.nameEn = null;
      this.basicInfoForm.nameTh = null;
      this.basicInfoForm.descriptionEn = null;
      this.basicInfoForm.descriptionTh = null;
      this.basicInfoForm.packageTypeId = null;
      this.basicInfoForm.ticketGroupTncsAttributes = null;
      this.basicInfoForm.sellingStartDate = null;
      this.basicInfoForm.sellingEndDate = null;
      this.basicInfoForm.urlLink = null;
      this.basicInfoForm.validStartDate = null;
      this.basicInfoForm.validEndDate = null;
      // paymentTypeIds
      this.acceptAllMethod = true;
      this.paymentTypeIds = [1, 2];
      // quantityPricingForm
      this.quantityPricingForm.price = 0;
      this.quantityPricingForm.discountPrice = 0;
      this.quantityPricingForm.quantity = 0;
      this.quantityPricingForm.defaultQty = 0;
      this.quantityPricingForm.limitPerOrder = null;
    },
    getListVoucher(payload) {
      return new Promise((resolve, reject) => {
        getListVoucher(payload)
          .then((response) => {
            const fmt2 = new Intl.DateTimeFormat("en-GB", {
              year: "numeric",
              day: "numeric",
              month: "short",
            });

            const dataFormat = response.data.map((item) => {
              const { attributes, id, type } = item;
              const dataItem = {
                type: type,
                voucherId: id,
                voucherName: attributes.name,
                price: attributes.discountPrice,
                quantity: attributes.quantity,
                defaultQty: attributes.quantity,
                qtySold: attributes.totalOrders,
                qtyRedeemed: attributes.totalRedeemed,
                validityPeriod: fmt2
                  .formatRange(
                    new Date(attributes.validStartDate),
                    new Date(attributes.validEndDate),
                  )
                  .replaceAll("–", " - ")
                  .replaceAll("Sept", "Sep"),
                sellingStartDate: attributes.sellingStartDate,
                sellingEndDate: attributes.sellingEndDate,
                restaurants: attributes.restaurants,
              };
              return dataItem;
            });
            this.data = dataFormat;

            this.pagination = response.meta;
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    getVoucherDetail(id) {
      console.log("getVoucherDetail");
      return new Promise((resolve, reject) => {
        getVoucherDetail(id)
          .then((response) => {
            if (response.data) {
              const voucherDetail = response.data?.attributes;
              // basicInfoForm
              this.basicInfoForm.nameEn = voucherDetail.nameEn;
              this.basicInfoForm.nameTh = voucherDetail.nameTh;
              this.basicInfoForm.descriptionEn = voucherDetail.descriptionEn;
              this.basicInfoForm.descriptionTh = voucherDetail.descriptionTh;
              this.basicInfoForm.packageTypeId = voucherDetail.packageType?.id;
              this.basicInfoForm.ticketGroupTncsAttributes = voucherDetail.termsConditions;
              this.basicInfoForm.sellingStartDate = voucherDetail.sellingStartDate;
              this.basicInfoForm.sellingEndDate = voucherDetail.sellingEndDate;
              this.basicInfoForm.urlLink = voucherDetail.urlLink;
              this.basicInfoForm.validStartDate = voucherDetail.validStartDate;
              this.basicInfoForm.validEndDate = voucherDetail.validEndDate;
              // paymentTypeIds
              this.paymentTypeIds = voucherDetail.paymentTypes;
              this.acceptAllMethod = this.paymentTypeIds.length >= 2;
              // quantityPricingForm
              this.quantityPricingForm.price = voucherDetail.price.cents / 100;
              this.quantityPricingForm.discountPrice = voucherDetail.discountPrice.cents / 100;
              this.quantityPricingForm.quantity = voucherDetail.quantity;
              this.quantityPricingForm.defaultQty = voucherDetail.quantity;
              this.quantityPricingForm.limitPerOrder = voucherDetail.limitPerOrder;
              resolve(response);
            } else {
              reject(response);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleEditVoucher(formData) {
      return new Promise((resolve, reject) => {
        updateVoucherDetail(formData)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    createVoucher() {
      return new Promise((resolve, reject) => {
        console.log(this.basicInfoForm);
        const formData = new FormData();
        formData.append("ticket_group[nameTh]", this.basicInfoForm.nameTh);
        formData.append("ticket_group[nameEn]", this.basicInfoForm.nameEn);
        formData.append("ticket_group[descriptionTh]", this.basicInfoForm.descriptionTh);
        formData.append("ticket_group[descriptionEn]", this.basicInfoForm.descriptionEn);
        formData.append("ticket_group[packageTypeId]", this.basicInfoForm.packageTypeId);
        formData.append("ticket_group[sellingStartDate]", this.basicInfoForm.sellingStartDate);
        formData.append("ticket_group[sellingEndDate]", this.basicInfoForm.sellingEndDate);
        formData.append("ticket_group[validStartDate]", this.basicInfoForm.validStartDate);
        formData.append("ticket_group[validEndDate]", this.basicInfoForm.validEndDate);
        formData.append("ticket_group[urlLink]", this.basicInfoForm.urlLink);
        formData.append("ticket_group[quantity]", this.quantityPricingForm.quantity);
        formData.append("ticket_group[discountPrice]", this.quantityPricingForm.discountPrice);
        formData.append("ticket_group[limitPerOrder]", this.quantityPricingForm.limitPerOrder);
        formData.append("ticket_group[price]", this.quantityPricingForm.price);
        transformToFormData(
          this.basicInfoForm.ticketGroupTncsAttributes,
          formData,
          "ticket_group[ticketGroupTncsAttributes]",
          true,
        );
        transformToFormData(this.paymentTypeIds, formData, "ticket_group[paymentTypeIds]");

        createVoucher(formData)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    duplicateVoucher(payload) {
      return new Promise((resolve, reject) => {
        duplicateVoucher(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    detailVoucherRedeem(formData) {
      this.voucherRedeemDetails = null;
      return new Promise((resolve, reject) => {
        detailVoucherRedeem(formData)
          .then((response) => {
            if (!response.data) {
              reject(response);
              return false;
            }
            this.voucherRedeemDetails = response.data.attributes;
            this.voucherRedeemGuestDetails = response.data.attributes.guestDetails;
            resolve(true);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    redeemVoucher(formData) {
      return new Promise((resolve, reject) => {
        redeemVoucher(formData)
          .then((response) => {
            if (!response.success) {
              reject(response);
              return false;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    updateVoucherRedeem(formData) {
      return new Promise((resolve, reject) => {
        updateVoucherRedeem(formData)
          .then((response) => {
            if (!response.success) {
              reject(response);
              return false;
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    deleteVoucher(payload) {
      return new Promise((resolve, reject) => {
        deleteVoucher(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    exportListVoucher(payload) {
      return new Promise((resolve, reject) => {
        exportListVoucher(payload)
          .then((response) => {
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
});
